"use client";

import { c as _c } from "react/compiler-runtime";
import { Separator as SeparatorPrimitive } from "radix-ui";
import * as React from "react";
import { cn } from "@/lib/utils";
function Separator(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      decorative: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const decorative = t2 === undefined ? true : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== decorative || $[8] !== orientation || $[9] !== props || $[10] !== t3) {
    t4 = <SeparatorPrimitive.Root data-slot="separator" decorative={decorative} orientation={orientation} className={t3} {...props} />;
    $[7] = decorative;
    $[8] = orientation;
    $[9] = props;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { Separator };